//import React, {useEffect, useState} from 'react';
import {  
  IonButtons,
  IonButton,
} from '@ionic/react'
import './DashboardGrid.css';
import {Button} from "primereact/button";
import React, {useEffect, useState} from "react";
import {WithAuthenticatorProps} from "@aws-amplify/ui-react";
import { fetchAuthSession  } from 'aws-amplify/auth';
async function getUserGroups() {
    const session = await fetchAuthSession();
    const groups = session?.tokens?.accessToken.payload['cognito:groups'] || [];
    return groups;
}
const NavComponent  = ({user,signOut}:WithAuthenticatorProps) => {
    const [state, setState] = useState({isAdmin:false})

    useEffect(() =>{
        getUserGroups().then((userGroups:any) =>{
            console.log("User Groups", userGroups)
            if(userGroups.indexOf("Admin") !== -1) {
                setState({...state, isAdmin:true})
            }
        })
    },[user])



  return (
    <IonButtons slot="secondary">
        <IonButton color="primary" routerLink="/auctions">Auctions</IonButton>
        <IonButton color="primary" routerLink="/profile">Profile</IonButton>
        {state.isAdmin && (
        <IonButton color="primary" routerLink="/admin-auctions">Admin</IonButton>
        )}
        <Button onClick={signOut}>Sign out</Button>
    </IonButtons>    
  );
};

export default NavComponent;
